import { useLazyQuery, useMutation } from '@apollo/client';
import { flatten, formatGeneric, formatTranslations } from '../dataParsing/searchItemFormatting';
import { CREATE_BADGE, DELETE_BADGE, PATCH_BADGE, GET_BADGE } from '../../../gql/queries/BADGES';


function formatBadgeQueryItem( l ) {

    return {
        ...l,
        id: l.badgeId,
        locales: formatTranslations( l.locales ),
        originalData: l,
    };
}

export const useBadgeQuery = () => {

    const [ fetchBadge ] = useLazyQuery( GET_BADGE, { fetchPolicy: 'no-cache' } );

    async function fetch( { id } ) {
        const variables = {
            badgeId: id
        };

        const [ result ] = [ await fetchBadge( { variables } ) ];

        const data = formatBadgeQueryItem( formatGeneric( flatten( result.data.badge ) ) );

        return { data };
    }

    return [ fetch ];
};

export const useCreateBadgeMutation = () => {

    const [ createBadge ] = useMutation( CREATE_BADGE );

    async function create( badge ) {
        const variables = {
            input: badge
        };

        const result = await createBadge( { variables } );

        const data = formatBadgeQueryItem( formatGeneric( flatten( result.data.createBadge ) ) );

        return { data };
    }

    return [ create ];
};

export const usePatchBadgeMutation = () => {

    const [ patchBadge ] = useMutation( PATCH_BADGE );

    async function patch( badge ) {
        const variables = {
            input: badge
        };

        const result = await patchBadge( { variables } );

        const data = formatBadgeQueryItem( formatGeneric( flatten( result.data.patchBadge ) ) );

        return { data };
    }

    return [ patch ];
};

export const useDeleteBadgeMutation = () => {

    const [ deleteBadgeMutation ] = useMutation( DELETE_BADGE );

    async function deleteBadge( badgeId ) {
        const variables = {
            input: {
                badgeId
            }
        };

        await deleteBadgeMutation( { variables } );

        return { success: true };
    }

    return [ deleteBadge ];
};
